<template>
    <p>As a BSI Scholar (Biological Sciences Initiative) working in the Integrative Physiology of Aging Laboratory, I developed reusable, organized code for an ongoing longitudinal study on the plasma matabalome and its correlations with the decline in physiological function with aging (Biological Age).</p><p>The work was published and can be found <a href="https://scholar.colorado.edu/concern/graduate_thesis_or_dissertations/7p88cg57g" target="_">here</a>.</p>
    <logo-scroller :logos="logos"><p>Tech used:</p></logo-scroller>
</template>

<script>
    import LogoScroller from '@/components/LogoScroller'

    export default {
        name: "ResearchTimeline",
        components: {
            LogoScroller
        },
        data () {
            return {
                logos: [
                    'R',
                    'python',
                    'git',
                    'git_hub'
                ]
            } 
        },
        computed: {

        },
        methods: {

        }    
    }
</script>

<style>

</style>